export default "__VITE_ASSET__C8gjDnfv__"